
import {first} from 'rxjs/operators';
import { Component, OnInit, Input, Inject } from "@angular/core";

import { Observable } from "rxjs";

import { FlowTemplate, State, Transition, SideEffect, Rule } from "../../../../../common/models/flow.dto";
import { GroupStub } from "../../../../../admin/models/group.model";
import { genId } from "../../../../../core/services/genId";
import { GroupService } from "../../../../../admin/services/group.service";
import { WorkOrderType } from "../../../../../common/models/work-order.model";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./../models/types";
import { DomainDefinitionService } from '../../../../services/domain-definition.service';
import { ReportSelectorService } from '../../../../../form-controls/services/report-selector.service';
import { LunaDomain } from '../../../../models/domain.model';
import { ReportTemplate } from '../../../../../models/comodel/mergefieldsmodel.model';


@Component({
    selector: "side-effect-kick-off-chiefs-order",
    templateUrl: "side-effect-kick-off-chiefs-order.component.html",
    standalone: false
})

export class SideEffectKickOffChiefsOrderComponent implements OnInit {
    selectedWorkOrderType: WorkOrderType = WorkOrderType.Review;
    sideEffect: SideEffect;
    template: FlowTemplate;
    transition: Transition;
    availableGroups = new Array<GroupStub>();
    availableTransitions = new Array<Transition>();
    selectedTransitionToExecuteOnIssuance: Transition;
    showWarning: boolean = false;
    state: State;
    chiefsOrderCategoriesDomain: LunaDomain;
    reportTemplates: ReportTemplate[] = [];
    categoryFetched: boolean = false;
    reportsFetched: boolean = false;
    selectedReportTemplateId: string = "";
    selectedTransitionKey: string = "";

    constructor(
        public readonly groupService: GroupService,
        public readonly domainService: DomainDefinitionService,
        public readonly reportTemplateService: ReportSelectorService,
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.sideEffect = data.sideEffect;
        this.template = data.template;
        this.transition = data.transition;
    }

    ngOnInit() {
        this.chiefsOrderCategoriesDomain = { values: [] } as LunaDomain;

        if (!this.sideEffect.configuration.transition) {
            this.sideEffect.configuration.transition = { key: "" } as Transition;
        }
        else
            this.selectedTransitionKey = this.sideEffect.configuration.transition.key;

        if (this.sideEffect.configuration.reportTemplate == null || this.sideEffect.configuration.reportTemplate == undefined) {
            this.sideEffect.configuration.reportTemplate = { id: "" } as ReportTemplate;
        }
        else
            this.selectedReportTemplateId = this.sideEffect.configuration.reportTemplate.id;

        if (!this.sideEffect.configuration.rule) {
            this.sideEffect.configuration.rule = this.generateDefaultRule();
        }
        this.getAvailableGroups();
        this.domainService.get("ChiefsOrderCategory").pipe().subscribe((result) => {
            this.chiefsOrderCategoriesDomain = result;
            this.categoryFetched = true;
        },
            (error) => {
                console.error(error);
            });

        this.reportTemplateService.getAllTemplates().pipe().subscribe((results) => {
            this.reportTemplates = results;
            this.reportsFetched = true;
        },
            (error) => {
                console.error(error);
            });
        this.getAvailableTransitions();
    }

    getAvailableGroups(): void {
        this.availableGroups.push({ id: "-1", displayName: "..." });
        (this.groupService.get({ stubs: true }) as Observable<GroupStub[]>).pipe(
            first())
            .subscribe(groups => {
                this.availableGroups = groups;
            });
    }

    getAvailableTransitions(): void {
        this.state = this.template.states.find(s => s.key === this.transition.toStateKey);
        this.availableTransitions.push({ key: "-1", name: "...", outgoingRules: [], sideEffects: [] });
        if (this.state) {
            for (let i = 0; i < this.state.transitions.length; i++) {
                const transition = this.state.transitions[i];
                if ((this.state.key === transition.fromStateKey) &&
                    (transition.fromStateKey === transition.toStateKey)) {
                    this.availableTransitions.push(transition);
                } else {
                    const destination = this.template.states.find(s => s.key === transition.toStateKey);
                    if (destination) {
                        this.availableTransitions.push(transition);
                    }
                }
            }
        }
    }

    changeReportTemplate(reportTemplateId: string): void {
        if (this.state) {
            let selectedReportTemplate = this.reportTemplates.find(t => t.id === reportTemplateId);
            this.sideEffect.configuration.reportTemplate = selectedReportTemplate;
        }
    }

    changeTransition(transitionId: string): void {
        if (this.state) {
            this.selectedTransitionToExecuteOnIssuance = this.state.transitions.find(t => t.key === transitionId);
            this.sideEffect.configuration.transition = this.selectedTransitionToExecuteOnIssuance;
        }
    }

    categorizedTemplates(): ReportTemplate[] {
        if (this.sideEffect.configuration.chiefsOrderCategory != "" && this.sideEffect.configuration.chiefsOrderCategory != null
            && this.sideEffect.configuration.chiefsOrderCategory != undefined) {
            return this.reportTemplates.filter(a => a.categoryCode == this.sideEffect.configuration.chiefsOrderCategory && a.typeCode == "co");
        }
        else
            return this.reportTemplates.filter(a => a.typeCode == "co");
    }

    generateDefaultRule(): Rule {
        return {
            ruleId: genId(),
            name: "Review Due Date",
            expression: "",
            key: undefined,
            message: ""
        } as Rule;
    }
}